<div class="ui-g-12 home-title" translate>HOME.TITLE</div>
<div class="ui-g-12 text-center">
    <img class="splash-image" src="assets/images/TD-splash.png">
</div>
<div class="ui-g-12">
    <p translate>HOME.ABOUT</p>
    <b translate>HOME.FEATURES</b>:<br/>
    <ul>
        <li translate>HOME.NOLIMITS</li>
        <li translate>HOME.SUPPORTSBRACKETTEAMS</li>
        <li translate>HOME.DISPLAYTEAMSUMMARY</li>
        <li translate>HOME.DATABACKUP</li>
        <li translate>HOME.CONFIGSETTINGS</li>
        <ul>
            <li translate>HOME.NUMBEROFROUNDS</li>
            <li translate>HOME.UNLIMITEDBRACKETS</li>
            <li translate>HOME.QUALTIMELIMITS</li>
            <li translate>HOME.BRACKETTIMELIMITS</li>
            <li translate>HOME.MATCHLENGTH</li>
            <li translate>HOME.RANDOMPITCH</li>
        </ul>
        <li translate>HOME.OUTPUTSCREEN</li>
        <li translate>HOME.COPYEVENTS</li>
        <li translate>HOME.IMPORTDMK</li>
        <li translate>HOME.ADJUSTRESULTS</li>
        <li translate>HOME.CUSTOMLOGO</li>
        <li translate>HOME.THEMES</li>
        <li translate>HOME.UNLIMITEDEVENTS</li>
        <li translate>HOME.UPDATEALERTS</li>
    </ul>
    <br />
    <p translate>HOME.BETAEVENTS</p>
    <ul>
        <li>2019 U.S. Kubb Open</li>
        <li>2019 - 2020 PA Kubb Championship</li>
        <li>2020 East Coast Kubb Championship</li>
        <li>2020-2021 Skuffle for the Shovel 1v1</li>
        <li>2019-2020 Illinios Kubb Championship</li>
        <li>2019 Kubbapalooza</li>
        <li>2019 Hot Iron Days Kubb Tournament</li>
        <li>2020 U.S. Virtual Kubb Championship</li>
        <li>All Keystone Kubb Virtual Kubb Leagues</li>
    </ul>
</div>